import { ErrorState } from './../interfaces/error-state';
import { createAction, props } from '@ngrx/store';

export const changeError = createAction('[Error] Change Error', props<{ errorState: ErrorState }>());
export const clearError = createAction('[Error] Clear Error');
